import { Exclude } from 'class-transformer';

export class QaTesterRawDto {
    moduleCode: string;
    userIds: string;

    // Transient
    @Exclude()
    isUpdated = false;

    @Exclude()
    usersList: string[];

    @Exclude()
    parentCode: string;

    @Exclude()
    visibility: boolean;
}
